import React, {useEffect, useState} from 'react';
import {collection, onSnapshot, query} from "firebase/firestore";
import db from "../firebase";
import Card from "./Card";

const Columns = (props) => {
  const {statuses} = props
  const [cards, setCards] = useState([])
  const getCards = async () => {
	const cardsColRef = query(collection(db, "cards"));
	onSnapshot(cardsColRef, (snapshot) => {
	  setCards(
		snapshot.docs.map((doc) => ({
		  id: doc.id,
		  ...doc.data(),
		}))
	  );
	});
  };

  useEffect(  () => {
	getCards()
  }, [])

  return (
	<>
	  <div className="container text-center">
		<div className="row align-items-top">
		  {statuses.sort((a, b) => a.column - b.column)
			.map(statusCol => {
			  return <div className="col-3" key={statusCol.id}>
				<h3>{statusCol.name}</h3>
				{cards.filter(card =>
				card.status === statusCol.name
				).map(card => <Card card={card} key={card.id} statuses={statuses}/>)
				}
			  </div>
			}

		  )}

		</div>
	  </div>
	</>
  );
};


export default Columns;
